import api from '@/api'

const namespaced = true

const state = {
  tentativeBargeSchedules: [],
  tentativeBargeScheduleDetails: [],
  shipperRep: [],
  loadingPlans: [],
  exportFile: {}
}

const getters = {
  tentativeBargeSchedules: state => state.tentativeBargeSchedules,
  tentativeBargeScheduleDetails: state => state.tentativeBargeScheduleDetails,
  shipperRep: state => state.shipperRep,
  loadingPlans: state => state.loadingPlans,
  exportFile: state => state.exportFile
}

const mutations = {
  SET_TENTATIVE_BARGE_SCHEDULES: (state, payload) => {
    state.tentativeBargeSchedules = payload
  },
  SET_TENTATIVE_BARGE_SCHEDULE_DETAILS: (state, payload) => {
    state.tentativeBargeScheduleDetails = payload
  },
  SET_SHIPPER_REP: (state, payload) => {
    state.shipperRep = payload
  },
  SET_LOADING_PLANS: (state, payload) => {
    state.loadingPlans = payload
  },
  SET_EXPORT_FILE: (state, payload) => {
    state.exportFile = payload;
  }
}

const actions = {
  async fetchTentativeBargeSchedules({ commit}, payload) {
    try {
      const { data } = await api.getTentativeBargeSchedules(payload)

      if (data.error) {
        commit('SET_TENTATIVE_BARGE_SCHEDULES', [])
        return
      }

      commit('SET_TENTATIVE_BARGE_SCHEDULES', data)
    } catch (err) {
      throw err
    }
  },
  async fetchTentativeBargeScheduleDetails({ commit}, payload) {
    try {
      const { data } = await api.getTentativeBargeScheduleDetails(payload)

      if (data.error) {
        commit('SET_TENTATIVE_BARGE_SCHEDULE_DETAILS', [])
        return
      }

      commit('SET_TENTATIVE_BARGE_SCHEDULE_DETAILS', data.tbs_data || [])
    } catch (err) {
      throw err
    }
  },
  async putTentativeBargeSchedules({}, payload) {
    try {
      await api.putTentativeBargeSchedules(payload.id, payload.form)
    } catch (err) {
      throw err
    }
  },
  async getShipperRep({ commit }) {
    try {
      const { data } = await api.getUsers( {
        active: true,
        group_name: 'Shipper Rep'
      })
      if (!data.error) {
        commit('SET_SHIPPER_REP', data.map(item => (
          { text: item.name, value: item.name }
        )))
      }
    } catch (err) {
      throw err
    }
  },
  async fetchTentativeBargeSchedulesLoadingPlans({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const { data } = await api.getLoadingPlans(payload ,{ ...(filterConfig.search && {search: filterConfig.search})})
      if (data.error) {
        commit('SET_LOADING_PLANS', [])
        return
      }

      commit('SET_LOADING_PLANS', data)
    } catch(err) {
      throw err
    }
  },
  async updateLoadingPlan({}, payload) {
    try {
      await api.putLoadingPlansUpdate(payload)
    } catch (err) {
      throw err
    }
  },
  async storeTentativeBargeScheduleDetail({}, payload) {
    try {
      await api.storeTentativeBargeScheduleDetail(payload)
    } catch (err) {
      throw err
    }
  },
  async exportTBS({ commit }, payload) {
    try {
      const response = await api.getTentativeBargeScheduleExcel(payload)
      if (response) {
        commit('SET_EXPORT_FILE', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetExportFiles({ commit }) {
    commit('SET_EXPORT_FILE', {})
  }
}

export default { namespaced, state, getters, mutations, actions }
